import React from 'react';
import Radium from 'radium';

import { buttonTypes } from 'types/sidebarTypes';

import SidebarDefaultButton from './components/SidebarDefaultButton';
import SidebarOpenableButton from './components/SidebarOpenableButton';
import SidebarActionButton from './components/SidebarActionButton';

const SidebarButton = props =>
  props.options && props.options.length > 1 ? (
    <SidebarOpenableButton {...props} />
  ) : props.linkTo || props.externalLink ? (
    <SidebarDefaultButton {...props} />
  ) : (
    <SidebarActionButton {...props} />
  );

SidebarButton.propTypes = buttonTypes;

// eslint-disable-next-line react/forbid-foreign-prop-types
export const { propTypes } = SidebarButton;

export default Radium(SidebarButton);
